import Vue from 'vue'

Vue.prototype.$globalEventBus = new Vue();
window.VueGlobalEventBus = Vue.prototype.$globalEventBus
